import { FindProductGridParams } from '../../../services/modules/product-grid/product-grid.types';
import { onlineProductGridRepository } from '../../../services/modules/product-grid/productGridRepository/onlineProductGrid.repository';
import { availabilityToAvailabilityEnum } from '../../products/utils/availability.utils';
import { OfflineGridBuilder } from '../builders/offlineGrid/OfflineGrid.builder';
import { offlineOrdersRepository } from '../repositories/offlineOrders.repository';
import { createApiSauceResponse } from '../utils/createApiSauceResponse.util';

export const productGridRepositoryOfflineAdapters: typeof onlineProductGridRepository = {
  findProductGrid: async ({
    orderId,
    availability,
    priceTableId,
    productColorId,
    deliveryWindowId,
    kitId,
  }: FindProductGridParams) => {
    if (!orderId && !priceTableId) {
      throw new Error('priceTableId is required in offline flow');
    }

    const offlineOrder = orderId ? await offlineOrdersRepository.getById(orderId) : undefined;

    const availabilityAsEnum = availabilityToAvailabilityEnum(availability);

    const offlineGridBuilder = new OfflineGridBuilder({
      offlineOrder,
      priceTableId,
      productColorId,
      availability: availabilityAsEnum,
      deliveryWindowId: deliveryWindowId ?? undefined,
      kitId: kitId,
    });

    const grid = await offlineGridBuilder.build();

    return createApiSauceResponse({
      ok: true,
      data: [grid],
    });
  },
};

export interface FindProductGridParamsToOffline {
  priceTableId?: string;
}
